import { scrollAnime } from "./components/scrollAnime";
import { humbergerMenuButton } from "./components/humbergerMenuButton";
import { accordion } from "./components/accordion";
import { tab } from "./components/tab";
import { slider } from "./components/slider";
import { inputError } from "./components/inputError";
import { megaMenu } from "./components/megaMenu";
import { pageTop } from "./components/pageTop";



$(function () {

  var isTop = $('.p-header').hasClass('p-header--top');
  var isSP = document.body.clientWidth < 768 ? true : false;

  pageTop('#toTop', false);

  // あと何日
  if($('.c-countdown__daynum')) {
    const targetYear = 2024;
    const targetMonth = 11;
    const targetDay = 20;
    var targetDate = new Date(targetYear, targetMonth - 1, targetDay);
    var targetTime = targetDate.getTime();
    var nowDate = new Date();
    var nowTime = nowDate.getTime();

    var diffMSec = targetTime - nowTime;
    var diffDays = diffMSec / (1000 * 60 * 60 * 24);
    var showDays = Math.ceil(diffDays);

    if(diffDays > 0) {
      $('.c-countdown__daynum').text(showDays);
    } else {
      // const ele = document.createElement('<p class="c-countdown__desc">');
      const wrapper = document.querySelector('.c-countdown__wrapper');

      const ele = document.createElement('p');
      ele.classList.add('c-countdown__anniversary');
      ele.innerHTML = "<span class=\"\">皆様のおかげで</span><br>祝100周年！";

      if(wrapper) {
        while (wrapper.firstChild) {
          wrapper.removeChild(wrapper.firstChild);
        }
        wrapper.appendChild(ele);
      }
    }


  }
  // あと何日(ここまで)

  // 100年の軌跡用タイムライン処理

  $('.p-history__block--right').each(function(){
    $(this).clone().appendTo('.p-history__contents__right');
  });

  // 100年の軌跡用タイムライン処理（ここまで）

  // $('#historyBtn').on('click', function() {
  //   $('#historyList').toggle();
  // });

  $('#historyItem').on('mouseover', function() {
    $('#historyList').show();
  });

  $('#historyItem').on('mouseout', function() {
    $('#historyList').hide();
  });

  $('#burger').on('click', function(e) {
    if($('.c-burger').hasClass('c-burger--active')) {
      $('.c-burger').removeClass('c-burger--active');
      $('.p-header__burger-menu').hide();
    } else {
      $('.c-burger').addClass('c-burger--active');
      $('.p-header__burger-menu').show();
    }
  });

  $(window).on('resize', function(e) {
    isSP = document.body.clientWidth < 768 ? true : false;
  });

  function bgSlideIn() {
    $('.p-top-history').each(function() {
      const elementPosition = $(this).offset().top + 500;
      const scroll = $(window).scrollTop();
      const winHeight = $(window).height();
      if(scroll >= elementPosition - winHeight) {
        $(this).addClass('p-top-history--anim');
      } else {
        // $(this).removeClass('fadeUp');
      }
    });

  }

  $(window).on('scroll', function(e) {
    bgSlideIn();
    if(!isSP && $(this).scrollTop() - $('.p-header-logo').height() > 0) {
    // if($(this).scrollTop() > 0) {
      // if(!$('.p-header').hasClass('p-header--fixed')) {
      //   $('.p-header').addClass('p-header--fixed');
      // }
      if(isTop) {
        $('.p-header').removeClass('p-header--top');
      }
    } else {
      // if($('.p-header').hasClass('p-header--fixed')) {
      //   $('.p-header').removeClass('p-header--fixed');
      // }
      if(isTop) {
        $('.p-header').addClass('p-header--top');
      }

    }
  });

  (() => {
    /*
    アニメーション用関数
    */
    //アニメーション用クラスを定義
    const animeEl = ".u-anime";
    //スクロール時に付与されるクラス定義
    const addAnimeClass = "fadeIn";
    scrollAnime(animeEl, addAnimeClass);

  })();

  (() => {
    /*
    ハンバーガーメニュー用関数
    */
    //ハンバーガーメニューボタンクラス定義
    const buttonEl = "#humberge-button";
    //ハンバーガーメニュークラス定義
    const menuEl = "#humberge-menu";
    humbergerMenuButton(buttonEl, menuEl);
  })();

  (() => {
    /*
    スライダー用関数
    */
    const sliderEl = ".swiper";
    slider(sliderEl);
  })();

  (() => {
    /*
    アコーディオン用関数
    */
    //アコーディオンラッパークラス定義
    const accordionEl = ".accordion";
    //アコーディオンボタンクラス定義
    const accordionButtonEl = ".accordionButton";
    //アコーディオンアイテムクラス定義
    const accordionItemEl = ".accordionItem";
    accordion(accordionEl, accordionButtonEl, accordionItemEl);
  })();

  (() => {
    /*
    タブ用関数
    */
    //タブボタンラッパークラス定義
    const tabButtonEl = ".tabButton";
    //タブコンテンツラッパークラス定義
    const tabContentsEl = ".tabContent";
    tab(tabButtonEl, tabContentsEl);
  })();

  (() => {
    /*
    メガメニュー用関数
    */
    //メガメニューラッパークラス定義
    const megaMenuEl = "#megaMenu";
    //メガメニューナビアイテムクラス定義
    const megaMenuItemEl = ".megaMenuItem";
    //メガメニューコンテンツクラス定義
    const megaMenuContents = ".megaMenuContents";
    megaMenu(megaMenuEl, megaMenuItemEl, megaMenuContents);
  })();

  (() => {
    /*
    フォームバリデーション用関数
    */
    //フォームラッパークラス定義
    const formEl = ".p-form";
    //エラー表示用クラス定義
    const addErrorClass = "c-error";
    //WPなどでフォームから出力されるエラークラスを定義
    const errorEl = "error";
    inputError(formEl, addErrorClass, errorEl);
  })();

  (() => {
    /*
    ページトップボタン用関数
    */
    //ボタンクラス定義
    const pageTopButtonEl = "#pageTop";
    //初期状態を定義
    const hide = true;
    pageTop(pageTopButtonEl, hide);
  })();

});
